import React from 'react';

const ToolbarRight = (): JSX.Element => (
  <svg viewBox="0 0 512 512">
    <g fill="#ffffff">
      <path d="M0,32h512v64H0V32z M192,128h320v64H192V128z M192,320h320v64H192V320z M0,224h512v64H0V224z M0,416h512v64H0V416z" />
    </g>
  </svg>
);

export default ToolbarRight;
